const SimilaresController = ControllerBase.extend({
    name: "SimilaresController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.model.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function() {

        return {
            url: "/Produto/_Similares",
            type: "post",
            cache: false,
            data: {
                codigoProduto: this.model.get("IdentificadorOrcamento") ? this.model.get("CodigoProduto") : this.model.get("Codigo"), // FNX-998, FNX-999, FNX-1001
            }
        };

    },

    renderizado: function() {
        this.carregar(this.collection);
        $("#menu-sub-consulta-produtos").hide();
        if (this.modoInclusao !== undefined && !this.modoInclusao) {
            $("#adicionar-similares").hide();
        }
    },

    paginar: function(e) {
        this.pesquisa.ActualPage = e.page;
        this.pesquisar();
    },

    pesquisar: function(data) {

        var pesquisa = this.pesquisa
            ? this.pesquisa
            : {
                NumeroPagina: 1,
                TamanhoPagina: 20,
                Codigo: this.model.get("Codigo"), //FNX-999 - Codigo: this.model.get("CodigoProduto")
            };

        var self = this;

        global.ajax({
            url: "/Produto/ConsultarSimilares",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(pesquisa),
            success: function(data) {
                self.carregar(data);
            }
        });


    },

    carregar: function(data) {

        if (!data || !data.Entities) {
            return;
        }

        this.similaresView = this.showView({
            region: {
                name: "similaresViewRegion",
                selector: "#produtos-similares-region"
            },
            view: {
                type: SimilaresView,
                args: {
                    model: this.model,
                    collection: new Backbone.Collection(data.Entities),
                    adicionarProdutosCallback: this.adicionarProdutosCallback
                }
            }
        });

        this.paginador = new Paginator({
            container: "#pesquisar-similares-page-container",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    }

})

window.SimilaresController = SimilaresController

export {
    SimilaresController
}